import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const PanelChrome = ({ className, header, children, isInteracting }) => (
	<div className={cx('panel-chrome', className)}>
		<div className='panel-chrome__header'>
			{header}
		</div>
		<div className={cx('panel-chrome__body', { 'panel-chrome__body--blocked': isInteracting })}>
			{isInteracting && <div className='panel-chrome__interaction-shield' aria-hidden />}
			{children}
		</div>
	</div>
);

PanelChrome.propTypes = {
	className: PropTypes.string,
	header: PropTypes.node.isRequired,
	children: PropTypes.node,
	isInteracting: PropTypes.bool
};

export default PanelChrome;
